module.exports = __webpack_public_path__ + "static/media/shupe.732ebfc5.jpg";